import moment from 'moment';

const REFTags = (doc, data, clinica, typeDocumentInvoice) => {
    var REF = doc.createElement("REF");

    //Tipo de Documento de Referencia (IV = INVOICE)
    var REF_1 = doc.createElement("REF_1");
    REF_1.innerHTML = "IV";
    REF.appendChild(REF_1);

    //Prefijo y Consecutivo de la Factura Origen
    var REF_2 = doc.createElement("REF_2");
    REF_2.innerHTML = data.facturaNumero.num_fac_ter.replace('-', '');
    REF.appendChild(REF_2);

    //Fecha en que se firmo el CUFE 
    var REF_3 = doc.createElement("REF_3");
    REF_3.innerHTML = moment(data.detallesReferenciaFactura.fecha_cufe).format("YYYY-MM-DD");
    REF.appendChild(REF_3);

    //Codigo CUFE de la Factura 
    var REF_4 = doc.createElement("REF_4");
    REF_4.innerHTML = data.detallesReferenciaFactura.cufe;
    REF.appendChild(REF_4);

    //Codigo CUFE de la Factura 
    var REF_5 = doc.createElement("REF_5");
    REF_5.innerHTML = "CUFE-SHA384";
    REF.appendChild(REF_5);

    return REF;
}

export default REFTags;